module.exports = __webpack_public_path__ + "48e18d99a17bb3f231c7289da2adfdc4.png";